// import axios from "axios"
import { inspectionAPI } from "../../axios";

export const actions = {

    //Inspection
    GetInspectionIncoming(context, data){
        return inspectionAPI.get(`Incoming/All/${data}`);
    },
    GetInspectionReceived(){
        return inspectionAPI.get(`InspectionPo/Received`);
    },
    ReceiveInspection(context, data){
        return inspectionAPI.put(`Incoming/Po/Receive/${data}`);
    },

}